import { useState, useEffect } from "react";
import { useGetAllBatchTypesQuery } from "src/services/BatchTypeService";

const useBatchTypes = () => {
    const [batchTypes, setBatchTypes] = useState<any[]>([]);
    const [isDataLoading, setIsDataLoading] = useState(true);

    const { data, isLoading, isFetching } = useGetAllBatchTypesQuery("");

    useEffect(() => {
        if (isLoading || isFetching) {
            setIsDataLoading(true);
        } else {
            const result: any[] = data?.data;
            setBatchTypes(result || []);
            setIsDataLoading(false);
        }
    }, [data, isLoading, isFetching]);

    return { batchTypes, isDataLoading };
};

export default useBatchTypes;
